import { StyleSheet, Text, TouchableWithoutFeedback, View } from "react-native";
import ZigzagView from "react-native-zigzag-view";
import PaymentInfo from "./PaymentInfo";

import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";
import { useState } from "react";

export default function Ticket({ creditInfo }) {
  const [moreInfo, setMoreinfo] = useState(false);
  return (
    <ZigzagView
      // style={{ margin: 8 }}
      backgroundColor={Colors.WHITE}
      surfaceColor={Colors.TICKET}
    >
      <TouchableWithoutFeedback onPress={() => setMoreinfo(!moreInfo)}>
        <View style={styles.viewData}>
          {/* <Text style={styles.titleSecondary}>{"Total a pagar"}</Text> */}
          <View style={styles.viewSubdata}>
            <PaymentInfo creditData={creditInfo} moreInfo={moreInfo} />
          </View>
        </View>
      </TouchableWithoutFeedback>
    </ZigzagView>
  );
}

const styles = StyleSheet.create({
  viewData: {
    paddingVertical: 16,
    alignItems: "center",
  },
  viewSubdata: {},
  titleSecondary: {
    color: Colors.BLACK,
    fontSize: Fonts.FONT_SIZE_24,
    fontWeight: "bold",
  },
});
